import { useState, useEffect } from "react";
import {GetCategories} from "../../../Api/Article";
import ArticleCategoryDTO from "../../../Models/DTOs/ArticleCategoryDTO";

function useFetchArticleCategories() {
    const [categories, setCategories] = useState<ArticleCategoryDTO[]>([]);
    const [categoriesLoading, setCategoriesLoading] = useState<boolean>(false);
    const [categoriesError, setCategoriesError] = useState<string>("");
    const [revision, setRevision] = useState(0);

    useEffect(() => {
        const abortController = new AbortController();
        setCategoriesLoading(true);
        setCategoriesError("");

        (async () => {
            try {
                const data = await GetCategories(abortController);
                if (!abortController.signal.aborted && data?.items) {
                    setCategories(data.items);
                }
            } catch (err: any) {
                if (!abortController.signal.aborted) {
                    console.error(err);
                    setCategoriesError("Failed to fetch categories.");
                }
            } finally {
                if (!abortController.signal.aborted) {
                    setCategoriesLoading(false);
                }
            }
        })();

        return () => abortController.abort();
    }, [revision]);

    return { categories, categoriesLoading, categoriesError,
        retryCategories: () => setRevision(value => value + 1) };
}

export default useFetchArticleCategories;
